import React from 'react'
import './main.css'
import logo from './img/logo.jpg'
import tw from './img/tw.png'
import tg from './img/tg.png'
import cl from './img/cl.jpg'
import { Link } from 'react-router-dom'
import vd from './img/vd.MP4'
import { DefaultPlayer as Video } from 'react-html5video'
import 'react-html5video/dist/styles.css'

function Main() {
  return (
    <div className='main'>
        <div className='hd'>
        <strong>Zill protocol</strong>

        <div className='links'>
            <a href='https://twitter.com/zillprotocol' target='/blank'>
                <img src={tw} alt='' />
            </a>

            <a href='http://t.me/Zillprotocol' target='/blank'>
                <img src={tg} alt='' />
            </a>
        </div>
        </div>



        <div className='header'>
        <div>
        <h2>Zill protocol</h2>
        <p>the life changing token you have been waiting for.</p>
        </div>

        <img src={logo} alt='' />

      </div>



        <div className='vid'>
        <div className='video'>
            <Video autoplay loop >
                    <source src={vd} type='video/webm' />
                    <source src={vd} type='video/mp4' />
                    <source src={vd} type='video/ogg' />
                </Video>
        </div>
        </div>

        <div className='bod'>
                <p>
                Zill protocol enables Web3 community members to participate in various activities such as approving proposals for protocol upgrades, staking for rewards, participating in burn auctions, and more.
                The $Zill token is the official token to be used for this project
                The project will be launching on BSC Blockchain The token would be available for presale and 3% of the supply will be distributed as airdrop.
                </p>

               

            <p className='sty' style={{backgroundColor:'rgba(0, 255, 255, 0.445)'}}>Zill protocol is a public, permissionless blockchain that is designed to offer high throughput with the ability to complete thousands of transactions per second. It seeks to solve the issue of blockchain scalability and speed by employing sharding as a second-layer scaling solution. The platform is home to many decentralized applications.</p>

            <p>The platform is home to many decentralized applications. Just like the days of Safemoon, babydogecoin and feg, the $Zill protocol is here to bring back this old days. We are not here for even 500k mc but we are going to hit millions of dollars mc. </p>

        <div>

        </div>
      </div>


      <div className='mid1'>

        <div className='mid_ban'>
        <p style={{backgroundColor:'rgba(0, 255, 255, 0.445)'}} >Zill Protocol is a blockchain portal for creating user-friendly dApps. Launching on August 15th, 2023, it offers growth, earnings, and exciting events. Stay updated on the platform's developments. </p>
        
        <div className='bo'>
        <h3>TOKENOMICS</h3><br/>


        <p>Total supply 
            <span>10m</span>
        </p>
        <p style={{backgroundColor:'rgba(0, 255, 255, 0.445)'}}>Liquidity 
            <span>70%</span>
        </p>
        <p style={{backgroundColor:'rgba(0, 255, 255, 0.445)'}}>Initial burn 
            <span>20%</span>
        </p>
        <p>Marketing 
            <span>10%</span>
        </p>
        </div>
        </div>


      </div>




    

    <div className='bottom'>
        <div className='btm' >
        <Link to='/map' className='lin'>
            <p>RoadMap</p>
        </Link>

        <Link to='/whitepaper' className='lin'>
           <p> White Paper</p>
        </Link>
        </div>

        
        <div>
            <h3>Get In Touch</h3>
            <p>team@zillprotocol.com</p>
            <div className='links'>
                <a href='https://twitter.com/zillprotocol' target='/blank'>
                    <img src={tw} alt='' />
                </a>

                <a href='http://t.me/Zillprotocol' target='/blank'>
                    <img src={tg} alt='' />
                </a>

                <p>© 2023 Zill protocol. All Rights Reserved.</p>

            </div>

        </div>
    </div>



    </div>
  )
}

export default Main